var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4.8,
    fill: "#FA541C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_636_2229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 13.4197C12.8522 13.4197 13.543 12.7289 13.543 11.8768C13.543 11.0247 12.8522 10.334 12.0001 10.334C11.148 10.334 10.4573 11.0247 10.4573 11.8768C10.4573 12.7289 11.148 13.4197 12.0001 13.4197Z",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4573 18.5625H13.543",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4573 15.9912H13.543",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3735 5.43997L13.7988 8.01465L15.8571 10.0729L18.4318 7.49826L16.3735 5.43997Z",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62868 5.44824L5.57153 7.50539",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62866 9.56203L9.68581 7.50488",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_636_2229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.80005 4.7998)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotIcon);
export default __webpack_public_path__ + "static/media/iot_icon.795be554647eb57938e4a4360d194620.svg";
export { ForwardRef as ReactComponent };